/* eslint-disable vue/valid-v-for */
<template>
  <v-navigation-drawer v-model="$store.state.layout.drawer" clipped app>
    <v-list dense nav shaped>
      <template v-for="item in items">
        <v-row v-if="item.header" :key="item.header">
          <v-col cols="6">
            <div v-if="item.header" class="ml-2 caption">{{ item.header }}</div>
          </v-col>
          <v-col cols="6">
            <div class="text-right mr-2 caption">{{ version }}</div>
          </v-col>
        </v-row>
        <v-list-group v-else-if="item.children" :key="item.title" v-model="item.model"
          :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item :to="child.path" class="ml-5" @click="child.click && child.click()"
            v-for="(child, i) in item.children" :key="i" link>
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider :key="item.name" v-else-if="item.divider"> </v-divider>
        <v-list-item v-else :key="item.title" link :to="item.path" @click="item.click && item.click()">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <!-- <ImeiSearch />
      <RestockSerial /> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import dashbaordService from "../../Home/service";
// import inventoryService from "../../Inventory/service";
// const ImeiSearch = () => import("@/components/ImeiSearch");
// const RestockSerial = () => import("@/components/RestockSerial");
const pjson = require("../../../../package.json");
// import navService from "../service";
// import sound from "../../../assets/audio/u_have_a_task.mp3";

// const audio = new Audio(sound);

export default {
  data() {
    return {
      items: [],
      mini: false,
      right: null,
      leadsBadge: 0,
      ticketsBadge: 0,
      taskBadge: 0,
      inventoryBadge: 0,
      locationBadge: 0,
    };
  },
  computed: {
    ...mapGetters("integration", ["modules"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    version() {
      return pjson.version;
    },
  },
  async mounted() {
    await this.loadNav();
  },
  methods: {
    ...mapActions("layout", ["setOpenSerialSearch", "setOpenRestockSerial"]),
    loadNav() {
      this.items = [];
      this.items.push({ header: "Menu" });
      this.items.push({
        title: this.$t("sideBar.home"),
        icon: "mdi-home-outline",
        name: "home",
        path: "/",
      });
      this.items.push({ divider: true });
      this.items.push({
        title: "Donors",
        icon: "mdi-chevron-down",
        "icon-alt": "mdi-chevron-right",
        name: "donors",
        path: "/donors",
        children: [
          {
            name: "donorList",
            icon: "mdi-hand-coin-outline",
            title: "List",
            path: "/donors",
          },
          {
            name: "paymentRequest",
            icon: "mdi-package-variant",
            title: "Payment Request",
            path: "/donors/paymentRequest/list",
          },
          {
            title: "Invoice",
            icon: "mdi-cart-outline",
            name: "invoice",
            path: "/invoice",
          },
        ],
      });
      this.items.push({ divider: true });

      this.items.push({
        title: "Parents",
        icon: "mdi-account-outline",
        name: "parents",
        path: "/parents",
      });

      this.items.push({
        title: "Students",
        icon: "mdi-account-school-outline",
        name: "student",
        path: "/students",
      });
      this.items.push({
        title: "Invoice",
        icon: "mdi-chevron-down",
        "icon-alt": "mdi-chevron-right",
        name: "invoice",
        children: [
          // {
          //   name: "donorList",
          //   icon: "mdi-hand-coin-outline",
          //   title: "List",
          //   path: "/list",
          // },
          
          {
            title: "Invoice",
            icon: "mdi-cart-outline",
            name: "invoice",
            path: "/invoice/list",
          },
          {
            name: "recurringInvoice",
            icon: "mdi-cash-sync",
            title: "Recurring Invoice",
            path: "/recurringInvoice/list",
          },
        ],
      });
      this.items.push({
        title: "Applications",
        icon: "mdi-filter-outline",
        name: "applications",
        path: "/applications",
      });

      this.items.push({
        title: "Administration",
        icon: "mdi-chevron-down",
        "icon-alt": "mdi-chevron-right",
        name: "administration",
        children: [
          {
            title: "Teachers",
            icon: "mdi-human-male-board",
            name: "teachers",
            path: "/teachers",
          },
          // {
          //   title: "Subjects",
          //   icon: "mdi-book-open-page-variant-outline",
          //   name: "subjects",
          //   path: "/subject",
          // },
          {
            name: "departments",
            icon: "mdi-google-classroom",
            title: "Departments",
            path: "/departments",
          },
          {
            name: "classRoom",
            icon: "mdi-google-classroom",
            title: "Class Rooms",
            path: "/classRoom",
          },
        ],
      });

      this.items.push({
        title: "Report Card",
        icon: "mdi-chevron-down",
        "icon-alt": "mdi-chevron-right",
        name: "administration",
        children: [
          {
            title: "Year",
            icon: "mdi-calendar-range",
            name: "year",
            path: "/reportcard/year",
          },
          {
            title: "Terms",
            icon: "mdi-clipboard-text-clock",
            name: "terms",
            path: "/reportcard/terms",
          },
          {
            title: "Subjects",
            icon: "mdi-text-long",
            name: "subject",
            path: "/reportcard/subject",
          },
          {
            title: "Grades",
            icon: "mdi-counter",
            name: "grades",
            path: "/reportcard/grades",
          },
          {
            title: "Curriculums",
            icon: "mdi-text-long",
            name: "curriculums",
            path: "/reportcard/curriculums",
          },
          {
            title: "Term Comments",
            icon: "mdi-text-long",
            name: "curriculums",
            path: "/reportcard/termComments",
          },
        ],
      });

      // this.items.push({
      //   title: "Teachers",
      //   icon: "mdi-human-male-board",
      //   name: "teachers",
      //   path: "/teachers",
      // });

      // this.items.push({
      //   name: "classes",
      //   icon: "mdi-google-classroom",
      //   title: "Classes",
      //   path: "/classes",
      // });

      // this.items.push({
      //   name: "classRoom",
      //   icon: "mdi-google-classroom",
      //   title: "Class Rooms",
      //   path: "/classRoom",
      // });

      // this.items.push({
      //   title: "Invoice",
      //   icon: "mdi-cart-outline",
      //   name: "invoice",
      //   path: "/invoice",
      // });

      // this.items.push({
      //   title: "List",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "inventory",
      //   path: "/inventory",
      //   children: [
      //     {
      //       name: "purchase",
      //       icon: "mdi-package-variant-closed",
      //       title: "Purchase",
      //       path: "/inventory/purchase",
      //     },
      //     {
      //       name: "purchaseOrder",
      //       icon: "mdi-package-variant",
      //       title: "Purchase Order",
      //       path: "/inventory/purchaseOrder",
      //     },
      //     {
      //       title: "Account",
      //       icon: "mdi-cellphone-android",
      //       name: "product",
      //       path: "/product/list",
      //     },
      //     {
      //       name: "vendor",
      //       icon: "mdi-truck-outline",
      //       title: "Vendor",
      //       path: "/inventory/vendor",
      //     },
      //     {
      //       name: "count",
      //       icon: "mdi-counter",
      //       title: "Count",
      //       path: "/inventory/count",
      //     },
      //   ],
      // });

      // this.items.push({
      //   title: "Order",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "order",
      //   children: [
      //     {
      //       name: "inHouse",
      //       icon: "mdi-office-building",
      //       title: "In House",
      //       path: "/order",
      //     },
      //     {
      //       name: "catalog",
      //       icon: "mdi-book-open-outline",
      //       title: "Catalog",
      //       path: "/catalog/create",
      //     },
      //     {
      //       name: "remote",
      //       icon: "mdi-tablet-cellphone",
      //       title: "Remote",
      //       path: "/RemoteView",
      //     },
      //   ],
      // });



      // this.items.push({
      //   title: "Product",
      //   icon: "mdi-cellphone-android",
      //   name: "product",
      //   path: "/product/list",
      // });
      // this.items.push({
      //   title: "Category",
      //   icon: "mdi-shape",
      //   name: "expense",
      //   path: "/inventory/category/list"
      // });

      // this.items.push({
      //   title: "Expense",
      //   icon: "mdi-wallet-outline",
      //   name: "expense",
      //   path: "/expense",
      // });

      
      this.items.push({
        title: "TV Adware",
        icon: "mdi-chevron-down",
        "icon-alt": "mdi-chevron-right",
        name: "tvAdware",
        children: [
          {
            title: "Screen",
            icon: "mdi-television",
            name: "screen",
            path: "/tvAdware/screen",
          },
          {
            title: "Ad Image",
            icon: "mdi-panorama-variant-outline",
            name: "adImage",
            path: "/tvAdware/adImage",
          },
        ]
      });

      this.items.push({
        title: "Report",
        icon: "mdi-chart-bell-curve",
        name: "report",
        path: "/report/home",
      });

      // this.items.push({
      //   title: "Serial Search",
      //   icon: "mdi-feature-search-outline",
      //   name: "serailSearch",
      //   click: () => {
      //     this.setOpenSerialSearch(true);
      //   },
      // });

      this.items.push({ divider: true });

      // this.items.push({
      //   title: this.$t("sideBar.list"),
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "list",
      //   path: "",
      //   children: [
      //     {
      //       name: "payee",
      //       icon: "mdi-account-check-outline",
      //       title: "Payee",
      //       path: "/expense/payee/list",
      //     },
      //     {
      //       name: "vendor",
      //       icon: "mdi-truck-outline",
      //       title: "Vender",
      //       path: "/inventory/vendor",
      //     },
      //     {
      //       name: "payments",
      //       icon: "mdi-cash-multiple",
      //       title: "Payments",
      //       path: "/customer/payment/home",
      //     },
      //   ],
      // });
      // this.items.push({
      //   title: "Deleted",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "deleted",
      //   path: "",
      //   children: [
      //     {
      //       name: "deleteCustomer",
      //       icon: "mdi-account-off-outline",
      //       title: "Deleted Customer",
      //       path: "/customer/deleted",
      //     },
      //     {
      //       name: "deletedInvoice",
      //       title: "Deleted Invoice",
      //       icon: "mdi-delete-off-outline",
      //       path: "/invoice/deleted",
      //     },
      //   ],
      // });

      // title: "List",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "inventory",
      //   path: "/inventory",

      this.items.push({
        title: "Admin Tools",
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        name: "adminTools",
        path: "/adminTools/home",
        children: [
          {
            title: "Financial Aid",
            icon: "mdi-wallet",
            name: "financialAid",
            path: "/sadqaFinancialAid",
          },

          {
            title: "Parents With No Invoice",
            icon: "mdi-cellphone-android",
            name: "noInvoice",
            path: "/parents/noInvoice",
          },
          {
            title: "Campaign",
            icon: "mdi-newspaper-variant-outline",
            name: "campaign",
            path: "/campaign/list",
          },
          // {
          //   title: "Donation Category",
          //   icon: "mdi-hand-coin-outline",
          //   name: "donationCategory",
          //   path: "/donationCategory/list",
          // },
          {
            title: "Setting",
            icon: "mdi-account-key-outline",
            name: "adminTools",
            path: "/adminTools/home",
          },
        ],
      });



      // this.items.push({
      //   title: this.$t("sideBar.adminTools"),
      //   group: "",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   children: [
      //     {
      //       name: "user",
      //       icon: "mdi-shield-account-outline",
      //       title: this.$t("sideBar.user"),
      //       path: "/user",
      //     },
      //     {
      //       name: "restock",
      //       icon: "mdi-barcode-scan",
      //       title: "Restock Serial",
      //       click: () => {
      //         this.setOpenRestockSerial(true);
      //       },
      //     },
      //     {
      //       name: "setting",
      //       icon: "mdi-cog-outline",
      //       title: "Setting",
      //       path: "/setting",
      //     },
      //   ],
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "@/scss/variable.scss";

// .sidebar-nav {
//   padding: 8px 35px 8px 15px;
//   display: block;
//   font-size: 15px;
//   border-radius: 4px;
//   white-space: nowrap;
//   color: $sidebar-text;
// }

.v-chip--x-small {
  font-size: 10px;
  height: 16px;
}

.v-chip--x-small .v-chip__content {
  line-height: 1;
  padding: 8px;
}
</style>
